import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  MobileListSectionComponent,
  TMobileListSectionItem,
} from '@prlw/common/mobile-list-section/mobile-list-section.component';
import { MobileOverlayCardComponent } from '@prlw/common/mobile-overlay-card/mobile-overlay-card.component';
import {
  MainTableColumn,
  MainTableColumnId,
} from '@prlw/core/monitor/types/main-table';

@Component({
  selector: 'prlw-mobile-manage-overlay-ui',
  standalone: true,
  imports: [MobileOverlayCardComponent, MobileListSectionComponent],
  templateUrl: './mobile-manage-overlay.component.html',
  styleUrl: './mobile-manage-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileManageOverlayComponent {
  @Input() items:
    | (TMobileListSectionItem & {
        column: MainTableColumn<MainTableColumnId>;
      })[]
    | null = [];

  @Output() eventClose = new EventEmitter();
  @Output() eventMobileListSectionItemClick = new EventEmitter<
    TMobileListSectionItem & { column: MainTableColumn<MainTableColumnId> }
  >();
  @Output() eventUpdateItemsInArray = new EventEmitter<
    (TMobileListSectionItem & { column: MainTableColumn<MainTableColumnId> })[]
  >();
}
